import React, { useEffect, useState } from "react";
import { sanityClient } from "../lib/sanityClient";
import VehicleCard from "./VehicleCard";

const VehicleList = ({ categorySlug }) => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVehicles = async () => {
      const query = `*[_type == "vehicle" && references(*[_type == "category" && slug.current == "${categorySlug}"]._id)]{
        title, slug, price, condition, primaryImage, categories[]->{slug}
      }`;
      const data = await sanityClient.fetch(query);
      setVehicles(data);
      setLoading(false);
    };
    fetchVehicles();
  }, [categorySlug]);

  if (loading) return <p className="text-center text-gray-600">Loading vehicles...</p>;
  if (vehicles.length === 0) return <p className="text-center text-gray-500">No vehicles found.</p>;

  return (
    <div className="container mx-auto px-4 py-6">
      <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">Available Vehicles</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {vehicles.map((vehicle) => (
          <VehicleCard key={vehicle.slug.current} vehicle={vehicle} />
        ))}
      </div>
    </div>
  );
};

export default VehicleList;
